exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n@media (min-width: 991px) {\r\n    .for-fixed-footer {\r\n        min-height: 100vh !important;\r\n        height: auto !important;\r\n        margin-bottom: -375px;\r\n        z-index: 0;\r\n    }\r\n    #for-fixed-footer-push, #fixed-footer {\r\n        height: 409px;\r\n        position: relative;\r\n    }\r\n}\r\n\r\n\r\n.sidenav-area {\r\n    position: fixed;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-direction: column;\r\n        flex-direction: column;\r\n}\r\n\r\n.mat-sidenav-container {\r\n    -ms-flex: 1;\r\n        flex: 1;\r\n}\r\n\r\n.router-outlet {\r\n    display: block;\r\n    min-height: 525px;\r\n}\r\n\r\n@media(max-width:767px) {\r\n    .titleContact button {\r\n        margin-top: 30px !important;\r\n        right: unset !important;\r\n        font-size: 10px;\r\n    }\r\n\r\n    .titleContact.mat-card-title {\r\n        margin-top: 50px !important;\r\n    }\r\n}\r\n\r\n.page-header {\r\n    border: none !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/app.component.css
// module id = ../../../../../client/app/app.component.css
// module chunks = main